module.exports = __webpack_public_path__ + "static/media/pin-secondary.98a7d80d.png";